import { Typography } from "antd";

export default function CardTitleCustom ({ text }: { text: string }) {
    return (
        <div style={{ width: '100%', height: '125px', borderRadius: '15px', backgroundImage: 'url("/img/welcome.jpg")', backgroundSize: '100% 100%', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',}}>
            <Typography style={{ fontSize: '32px', color: 'white', placeContent: 'center', textAlign: 'center', height: '100%' }}>{text}</Typography>
        </div>
    )
}